import type { FC } from "react";
import ChatDashboard from "./ChatDashboard";
import AdminHomeDashboard from "./AdminHomeDashboard";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { agentRoles } from "../constants/agent";

const HomeRoute: FC = function () {
    const user = useCurrentUser();
    const role = user?.agent_role;

    // company_admin (and super_admin) lands on the dashboard with stats.
    // Everyone else lands directly in the chat workspace.
    if (role === agentRoles.company_admin || role === agentRoles.super_admin) {
        return <AdminHomeDashboard />;
    }

    return <ChatDashboard />;
};

export default HomeRoute;
